import { useEffect, useState } from "react";
import { Images, Video } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import ImageField from "./ImageField";

export default function HeroModePanel() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then((r) => setForm(r.data)).catch(() => toast.error("Failed to load settings"));
  }, []);

  if (!form) return null;
  const mode = form.hero_mode || "carousel";

  const save = async (patch) => {
    setSaving(true);
    try {
      const r = await api.put("/admin/settings", { ...form, ...patch });
      setForm(r.data);
      toast.success("Hero display updated");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  const modeCard = (value, icon, title, desc) => {
    const active = mode === value;
    return (
      <button
        type="button"
        data-testid={`hero-mode-${value}`}
        onClick={() => !active && save({ hero_mode: value })}
        disabled={saving}
        className={`flex-1 min-w-[180px] flex items-start gap-3 rounded-xl border p-4 text-left transition-colors ${
          active ? "border-[#9A7B66] bg-[#F4EFEA]" : "border-[#E5DED4] bg-white hover:border-[#D8CBB8]"
        }`}
      >
        <span className={`mt-0.5 ${active ? "text-[#9A7B66]" : "text-[#A0988E]"}`}>{icon}</span>
        <span>
          <span className="block text-xs font-sans font-semibold text-[#2C2825]">{title}</span>
          <span className="block text-[11px] font-sans text-[#A0988E] mt-0.5 leading-snug">{desc}</span>
        </span>
      </button>
    );
  };

  return (
    <div data-testid="hero-mode-panel" className="bg-white border border-[#E5DED4] rounded-xl p-5 mb-6">
      <h3 className="font-serif text-lg text-[#2C2825] mb-1">Hero Display Mode</h3>
      <p className="text-xs text-[#A0988E] mb-4">
        Pilih apakah hero homepage menampilkan karosel gambar atau satu video. Bisa diganti kapan saja.
      </p>
      <div className="flex flex-wrap gap-3">
        {modeCard("carousel", <Images className="w-4 h-4" />, "Image Carousel", "Kelola slide foto di bawah (maks 10, drag untuk urutkan).")}
        {modeCard("video", <Video className="w-4 h-4" />, "Background Video", "Satu video full-screen (MP4/WEBM, usahakan di bawah 20MB).")}
      </div>
      {mode === "video" && (
        <div className="grid sm:grid-cols-2 gap-5 mt-5 pt-5 border-t border-[#E5DED4]">
          <div>
            <p className="text-[11px] font-sans font-semibold text-[#6E675F] mb-2">Hero Video (MP4/WEBM)</p>
            <ImageField
              testId="hero-mode-video-input"
              value={form.hero_video_url || ""}
              onChange={(v) => save({ hero_video_url: v })}
              accept="video/mp4,video/webm,video/quicktime"
            />
          </div>
          <div>
            <p className="text-[11px] font-sans font-semibold text-[#6E675F] mb-2">Poster (tampil saat video loading)</p>
            <ImageField
              testId="hero-mode-poster-input"
              value={form.hero_video_poster || ""}
              onChange={(v) => save({ hero_video_poster: v })}
              accept="image/*"
            />
          </div>
        </div>
      )}
    </div>
  );
}
